<template>
  <ContentWrap>
    <el-form :inline="true" :model="queryParams" class="-mb-15px">
      <el-form-item label="标题" prop="title">
        <el-input
          v-model="queryParams.title"
          placeholder="请输入活动标题"
          clearable
          class="!w-200px"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="分类" prop="categoryId">
        <el-select v-model="queryParams.categoryId" placeholder="请选择" clearable class="!w-150px">
          <el-option v-for="c in categoryList" :key="c.id" :label="c.name" :value="c.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="标签" prop="tagId">
        <el-select v-model="queryParams.tagId" placeholder="请选择" clearable class="!w-150px">
          <el-option v-for="tag in tagList" :key="tag.id" :label="tag.name" :value="tag.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="queryParams.status" placeholder="请选择" clearable class="!w-150px">
          <el-option v-for="s in STATUS_OPTIONS" :key="s.value" :label="s.label" :value="s.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="活动形式" prop="mode">
        <el-select v-model="queryParams.mode" placeholder="全部" clearable class="!w-120px">
          <el-option label="线下" :value="1" />
          <el-option label="线上" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="收费类型" prop="chargeType">
        <el-select v-model="queryParams.chargeType" placeholder="全部" clearable class="!w-120px">
          <el-option label="免费" :value="1" />
          <el-option label="收费" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="会员专享" prop="memberOnly">
        <el-select v-model="queryParams.memberOnly" placeholder="全部" clearable class="!w-120px">
          <el-option label="是" :value="true" />
          <el-option label="否" :value="false" />
        </el-select>
      </el-form-item>
      <el-form-item label="开始时间" prop="stime">
        <el-date-picker
          v-model="queryParams.stime"
          type="datetimerange"
          range-separator="-"
          start-placeholder="开始"
          end-placeholder="结束"
          value-format="YYYY-MM-DD HH:mm:ss"
          class="!w-350px"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleQuery"><Icon icon="ep:search" /> 搜索</el-button>
        <el-button @click="resetQuery"><Icon icon="ep:refresh" /> 重置</el-button>
        <el-button
          type="primary"
          plain
          @click="openForm('create')"
          v-hasPermi="['activity:activity:create']"
        >
          <Icon icon="ep:plus" /> 新增活动
        </el-button>
      </el-form-item>
    </el-form>

    <!-- 状态 Tab 筛选 -->
    <el-tabs v-model="activeTab" @tab-change="handleTabChange" class="mt-12px">
      <el-tab-pane v-for="t in TAB_LIST" :key="t.value" :name="t.value">
        <template #label>
          <span>
            {{ t.label }}
            <el-badge
              v-if="t.value === 1 && pendingCount > 0"
              :value="pendingCount"
              class="ml-1"
              type="danger"
            />
          </span>
        </template>
      </el-tab-pane>
    </el-tabs>

    <el-table v-loading="loading" :data="list" border>
      <el-table-column label="图标" prop="cover" width="80">
        <template #default="scope">
          <el-image
            v-if="scope.row.cover"
            :src="scope.row.cover"
            style="width: 50px; height: 32px"
            :preview-src-list="[scope.row.cover]"
          />
        </template>
      </el-table-column>
      <el-table-column label="活动标题" prop="title" min-width="180" show-overflow-tooltip />
      <el-table-column label="活动分类" prop="categoryId" width="120">
        <template #default="scope">
          <span>{{ getCategoryName(scope.row.categoryId) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="报名人数" prop="signNum" width="100" align="center">
        <template #default="scope">
          <span>{{ scope.row.signNum || 0 }} / {{ scope.row.maxNum }}</span>
        </template>
      </el-table-column>
      <el-table-column label="活动时间" width="190">
        <template #default="scope">
          <div>{{ formatDate(scope.row.stime) }}</div>
          <div class="text-gray-400 text-xs">~ {{ formatDate(scope.row.etime) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status" width="100">
        <template #default="scope">
          <el-tag :type="getStatusTagType(scope.row.status)">{{
            getStatusLabel(scope.row.status)
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="推荐" prop="isRec" width="70">
        <template #default="scope">
          <el-tag v-if="scope.row.isRec" type="success" size="small">推荐</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="添加时间" prop="createTime" width="170" :formatter="dateFormatter" />
      <el-table-column label="操作" align="center" width="380" fixed="right">
        <template #default="scope">
          <el-button
            v-if="scope.row.status === 1"
            link
            type="primary"
            @click="openAudit(scope.row)"
            v-hasPermi="['activity:activity:audit']"
          >
            审核
          </el-button>
          <el-button
            link
            type="primary"
            @click="openForm('update', scope.row.id)"
            v-hasPermi="['activity:activity:update']"
          >
            编辑
          </el-button>
          <el-button
            link
            type="success"
            @click="openCheckinQrcode(scope.row.id)"
            v-hasPermi="['activity:activity:query']"
          >
            签到码
          </el-button>
          <el-button
            link
            type="primary"
            @click="goSignups(scope.row.id)"
            v-hasPermi="['activity:signup:query']"
          >
            报名记录
          </el-button>
          <el-button
            link
            type="primary"
            @click="goReports(scope.row.id)"
            v-hasPermi="['activity:report:query']"
          >
            举报
          </el-button>
          <el-button
            v-if="scope.row.status !== 6"
            link
            type="warning"
            @click="handleClose(scope.row.id)"
            v-hasPermi="['activity:activity:update']"
          >
            关闭
          </el-button>
          <el-button
            link
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-hasPermi="['activity:activity:delete']"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <Pagination
      v-model:page="queryParams.pageNo"
      v-model:limit="queryParams.pageSize"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <!-- 活动签到二维码 -->
  <Dialog v-model="checkinQrVisible" title="活动签到二维码" width="480px">
    <div class="checkin-qr-box">
      <div class="checkin-qr-title">{{ checkinQr.title || '活动签到码' }}</div>
      <img v-if="checkinQr.dataUrl" :src="checkinQr.dataUrl" class="checkin-qr-img" alt="签到二维码" />
      <el-skeleton v-else animated style="width: 240px; height: 240px" />
      <div class="checkin-qr-tip">{{ checkinQr.tip }}</div>
      <div class="checkin-qr-time" v-if="checkinQr.checkinStartTime || checkinQr.checkinEndTime">
        签到时段：
        {{ formatDate(checkinQr.checkinStartTime) || '-' }}
        ~
        {{ formatDate(checkinQr.checkinEndTime) || '-' }}
      </div>
      <el-input v-model="checkinQr.payload" readonly class="mt-12px">
        <template #append>
          <el-button @click="copyCheckinPayload">复制</el-button>
        </template>
      </el-input>
    </div>
  </Dialog>

  <!-- 活动表单弹窗 -->
  <Dialog v-model="dialogVisible" :title="dialogTitle" width="1100px" top="3vh">
    <el-form ref="formRef" :model="formData" :rules="formRules" label-width="110px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="活动标题" prop="title">
            <el-input v-model="formData.title" placeholder="请输入活动标题" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="活动副标题" prop="subtitle">
            <el-input v-model="formData.subtitle" placeholder="请输入活动副标题" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="活动标签" prop="tagIds">
            <el-select
              v-model="formData.tagIds"
              multiple
              clearable
              placeholder="请选择活动标签"
              class="!w-full"
            >
              <el-option v-for="tag in tagList" :key="tag.id" :label="tag.name" :value="tag.id" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider content-position="left">报名规则与表单</el-divider>
      <el-form-item label="人工审核">
        <el-switch v-model="formData.signupAuditEnabled" />
      </el-form-item>
      <el-form-item label="报名字段">
        <div class="w-full">
          <div
            v-for="(field, index) in signupFormFields"
            :key="field.key + index"
            class="mb-10px grid grid-cols-[120px_1fr_1fr_80px_40px] gap-8px"
          >
            <el-select v-model="field.type">
              <el-option label="单行文本" value="text" />
              <el-option label="手机号" value="mobile" />
              <el-option label="数字" value="number" />
              <el-option label="多行文本" value="textarea" />
            </el-select>
            <el-input v-model="field.label" placeholder="字段名称" />
            <el-input v-model="field.key" placeholder="字段标识" />
            <el-checkbox v-model="field.required">必填</el-checkbox>
            <el-button text type="danger" title="删除字段" @click="removeSignupField(index)">
              <Icon icon="ep:delete" />
            </el-button>
          </div>
          <el-button plain type="primary" @click="addSignupField"
            ><Icon icon="ep:plus" />新增字段</el-button
          >
        </div>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="活动形式" prop="mode">
            <el-segmented
              v-model="formData.mode"
              :options="[
                { label: '线下', value: 1 },
                { label: '线上', value: 2 }
              ]"
            />
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="所在地区" prop="regionPath">
            <el-cascader
              v-model="formData.regionPath"
              :options="areaTree"
              :props="areaCascaderProps"
              placeholder="请选择省 / 市 / 区"
              clearable
              filterable
              class="!w-full"
              @change="onRegionChange"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="活动分类" prop="categoryId">
            <el-select v-model="formData.categoryId" placeholder="请选择" class="!w-full">
              <el-option v-for="c in categoryList" :key="c.id" :label="c.name" :value="c.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="活动单位" prop="companyName">
            <el-input
              v-model="formData.companyName"
              placeholder="多个单位换行分隔"
              type="textarea"
              :rows="2"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="嘉宾姓名" prop="speakerName">
            <el-input v-model="formData.speakerName" maxlength="64" placeholder="选填，详情页展示" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="嘉宾头衔" prop="speakerTitle">
            <el-input v-model="formData.speakerTitle" maxlength="128" placeholder="选填，如职务 / 机构" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="海报短标题" prop="keywords">
            <el-input
              v-model="formData.keywords"
              maxlength="64"
              placeholder="选填，详情海报主标题；不填则用活动标题"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="报名须知" prop="signupNotice">
            <el-input
              v-model="formData.signupNotice"
              type="textarea"
              :rows="3"
              maxlength="2000"
              show-word-limit
              placeholder="选填，详情页展示；不填则用平台默认须知"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="封面图" prop="cover">
            <el-input v-model="formData.cover" placeholder="请选择封面图片">
              <template #append>
                <el-button @click="openMediaSelector('cover')">🗂素材库</el-button>
              </template>
            </el-input>
            <el-image
              v-if="formData.cover"
              :src="formData.cover"
              style="width: 80px; height: 60px; margin-top: 8px"
              :preview-src-list="[formData.cover]"
              fit="cover"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="封面图二" prop="bigCover">
            <el-input v-model="formData.bigCover" placeholder="请选择封面图片二">
              <template #append>
                <el-button @click="openMediaSelector('bigCover')">🗂素材库</el-button>
              </template>
            </el-input>
            <el-image
              v-if="formData.bigCover"
              :src="formData.bigCover"
              style="width: 80px; height: 60px; margin-top: 8px"
              :preview-src-list="[formData.bigCover]"
              fit="cover"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="活动地址" prop="address">
        <el-input v-model="formData.address" placeholder="请输入活动地点，也可通过地图选点回填" />
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="经度" prop="lng">
            <el-input v-model="formData.lng" placeholder="经度" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="纬度" prop="lat">
            <el-input v-model="formData.lat" placeholder="纬度" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="地图选点">
            <el-button type="primary" plain @click="openMapPicker">
              <Icon icon="ep:location" class="mr-5px" />
              打开地图选点
            </el-button>
            <div class="mt-4px text-12px text-gray-400">基于高德地图，可搜索或点击地图标点</div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="乘车路线" prop="busLine">
        <el-input
          v-model="formData.busLine"
          type="textarea"
          :rows="2"
          placeholder="请输入乘车路线"
        />
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="活动开始时间" prop="stime">
            <el-date-picker
              v-model="formData.stime"
              type="datetime"
              value-format="YYYY-MM-DD HH:mm:ss"
              placeholder="选择开始时间"
              class="!w-full"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="活动结束时间" prop="etime">
            <el-date-picker
              v-model="formData.etime"
              type="datetime"
              value-format="YYYY-MM-DD HH:mm:ss"
              placeholder="选择结束时间"
              class="!w-full"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="报名开始时间" prop="bmStime">
            <el-date-picker
              v-model="formData.bmStime"
              type="datetime"
              value-format="YYYY-MM-DD HH:mm:ss"
              placeholder="选择报名开始时间"
              class="!w-full"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="报名结束时间" prop="bmEtime">
            <el-date-picker
              v-model="formData.bmEtime"
              type="datetime"
              value-format="YYYY-MM-DD HH:mm:ss"
              placeholder="选择报名结束时间"
              class="!w-full"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="签到开始时间" prop="checkinStartTime">
            <el-date-picker
              v-model="formData.checkinStartTime"
              type="datetime"
              value-format="YYYY-MM-DD HH:mm:ss"
              placeholder="选择签到开始时间"
              class="!w-full"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="签到结束时间" prop="checkinEndTime">
            <el-date-picker
              v-model="formData.checkinEndTime"
              type="datetime"
              value-format="YYYY-MM-DD HH:mm:ss"
              placeholder="选择签到结束时间"
              class="!w-full"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="参与人数" prop="maxNum">
            <div class="w-full" @wheel.prevent>
              <el-input-number
                v-model="formData.maxNum"
                :min="1"
                :max="999999"
                :step="1"
                :precision="0"
                :value-on-clear="1"
                controls-position="right"
                class="!w-full"
              />
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <!-- 非必填：0 = 免费；>0 提交时自动 chargeType=收费 -->
          <el-form-item label="报名费用" prop="bmPrice">
            <div class="w-full" @wheel.prevent>
              <el-input-number
                v-model="formData.bmPrice"
                :min="0"
                :step="0.01"
                :precision="2"
                :value-on-clear="0"
                controls-position="right"
                class="!w-full"
                placeholder="0 表示免费"
                @change="syncChargeTypeByPrice"
              />
            </div>
          </el-form-item>
        </el-col>
        <!-- 活动.points 无业务消费；积分在「活动配置」配报名/签到/邀请奖励，此处不再展示 -->
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="男性名额" prop="maleLimit">
            <el-input-number v-model="formData.maleLimit" :min="0" class="!w-full" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="女性名额" prop="femaleLimit">
            <el-input-number v-model="formData.femaleLimit" :min="0" class="!w-full" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="最小年龄" prop="minAge">
            <el-input-number v-model="formData.minAge" :min="0" class="!w-full" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="最大年龄" prop="maxAge">
            <el-input-number v-model="formData.maxAge" :min="0" class="!w-full" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="收费类型" prop="chargeType">
            <el-segmented
              v-model="formData.chargeType"
              :options="[
                { label: '免费', value: 1 },
                { label: '收费', value: 2 }
              ]"
              @change="onChargeTypeChange"
            />
          </el-form-item>
        </el-col>
        <!-- 暂不开放会员专享开关
        <el-col :span="8">
          <el-form-item label="会员专享" prop="memberOnly">
            <el-switch v-model="formData.memberOnly" />
          </el-form-item>
        </el-col>
        -->
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="活动排序" prop="displayOrder">
            <!-- 包一层拦截滚轮，避免鼠标滚动改值；precision=0 禁小数/科学计数法 -->
            <div class="w-full" @wheel.prevent>
              <el-input-number
                v-model="formData.displayOrder"
                :min="0"
                :max="255"
                :step="1"
                :precision="0"
                :value-on-clear="0"
                controls-position="right"
                class="!w-full"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="活动描述" prop="intro">
        <Editor v-model="formData.intro" height="200px" />
      </el-form-item>
      <el-form-item label="详细说明" prop="activityDescription">
        <Editor v-model="formData.activityDescription" height="200px" />
      </el-form-item>
      <el-form-item label="往期回顾" prop="review">
        <Editor v-model="formData.review" height="150px" />
      </el-form-item>
      <el-form-item label="是否推荐" prop="isRec">
        <el-switch v-model="formData.isRec" :active-value="true" :inactive-value="false" />
      </el-form-item>
      <el-form-item label="是否开放评价" prop="reviewEnabled">
        <el-switch
          v-model="formData.reviewEnabled"
          :active-value="true"
          :inactive-value="false"
          active-text="开放"
          inactive-text="关闭"
        />
        <span class="ml-8px text-12px color-#909399">关闭后该活动用户端不再出现评价入口，已提交的评价不删除</span>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="submitForm">提 交</el-button>
    </template>
  </Dialog>

  <!-- 审核弹窗 -->
  <Dialog v-model="auditDialogVisible" title="活动审核" width="500px">
    <el-form ref="auditFormRef" :model="auditForm" :rules="auditRules" label-width="100px">
      <el-form-item label="活动标题">
        <span>{{ auditForm.title }}</span>
      </el-form-item>
      <el-form-item label="审核结果" prop="pass">
        <el-radio-group v-model="auditForm.pass">
          <el-radio :value="true">通过</el-radio>
          <el-radio :value="false">拒绝</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="auditForm.pass === false" label="拒绝原因" prop="reason">
        <el-input
          v-model="auditForm.reason"
          type="textarea"
          :rows="3"
          placeholder="请填写拒绝原因"
          maxlength="255"
          show-word-limit
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="auditDialogVisible = false">取 消</el-button>
      <el-button type="primary" :loading="auditSubmitting" @click="submitAudit">确 定</el-button>
    </template>
  </Dialog>

  <MediaSelector v-model="mediaVisible" :media-type="'IMAGE'" @confirm="onMediaConfirm" />

  <!-- 高德地图选点：回填经纬度 / 地址 / 尽量同步省市区 -->
  <AmapDialog ref="amapRef" @confirm="handleMapConfirm" />
</template>

<script setup lang="ts">
import MediaSelector from '@/components/MediaSelector/index.vue'
import { AmapDialog } from '@/components/Amap'
import { dateFormatter } from '@/utils/formatTime'
import { formatDate } from '@/utils/formatTime'
import * as ActivityApi from '@/api/activity/activity'
import * as CategoryApi from '@/api/activity/category'
import * as TagApi from '@/api/activity/tag'
import { getAreaTree } from '@/api/system/area'
import { findStoreAreaPathByNames } from '@/views/o2o/utils/storeArea'
import QRCode from 'qrcode'

defineOptions({ name: 'Activity' })

const message = useMessage()
const router = useRouter()
const route = useRoute()
const loading = ref(true)
const list = ref<any[]>([])
const total = ref(0)
const categoryList = ref<any[]>([])
const tagList = ref<any[]>([])
const pendingCount = ref(0)

const STATUS_OPTIONS = [
  { value: 0, label: '草稿' },
  { value: 1, label: '待审核' },
  { value: 2, label: '已拒绝' },
  { value: 3, label: '已发布' },
  { value: 4, label: '进行中' },
  { value: 5, label: '已结束' },
  { value: 6, label: '已关闭' }
]
const STATUS_LABELS: Record<number, string> = {
  0: '草稿',
  1: '待审核',
  2: '已拒绝',
  3: '已发布',
  4: '进行中',
  5: '已结束',
  6: '已关闭'
}
const STATUS_TYPES: Record<number, any> = {
  0: 'info',
  1: 'warning',
  2: 'danger',
  3: 'success',
  4: 'primary',
  5: 'info',
  6: 'danger'
}

const TAB_LIST = [
  { value: '', label: '全部' },
  { value: 1, label: '待审核' },
  { value: 3, label: '已发布' },
  { value: 4, label: '进行中' },
  { value: 5, label: '已结束' },
  { value: 6, label: '已关闭' }
]
const activeTab = ref<number | string>('')

const queryParams = reactive({
  pageNo: 1,
  pageSize: 20,
  title: '',
  categoryId: undefined as number | undefined,
  tagId: undefined as number | undefined,
  status: undefined as number | undefined,
  mode: undefined as number | undefined,
  chargeType: undefined as number | undefined,
  memberOnly: undefined as boolean | undefined,
  stime: [] as string[]
})

const getList = async () => {
  loading.value = true
  try {
    const params: any = { ...queryParams }
    if (params.stime && params.stime.length === 2) {
      params.stime = params.stime
    } else {
      delete params.stime
    }
    const data = await ActivityApi.getActivityPage(params)
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}

const getPendingCount = async () => {
  try {
    const data = await ActivityApi.getPendingAuditCount()
    pendingCount.value = Number(data) || 0
  } catch (e) {
    pendingCount.value = 0
  }
}

const loadCategoryList = async () => {
  try {
    const data = await CategoryApi.getCategoryListAll(0)
    categoryList.value = data || []
  } catch (e) {
    categoryList.value = []
  }
}

const loadTagList = async () => {
  try {
    tagList.value = (await TagApi.getTagListAll(0)) || []
  } catch (e) {
    tagList.value = []
  }
}

const getCategoryName = (id: number) => {
  const c = categoryList.value.find((x) => x.id === id)
  return c ? c.name : id
}

const getStatusLabel = (status: number) => STATUS_LABELS[status] || '-'
const getStatusTagType = (status: number) => STATUS_TYPES[status] || 'info'

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}
const resetQuery = () => {
  queryParams.title = ''
  queryParams.categoryId = undefined
  queryParams.tagId = undefined
  queryParams.status = undefined
  queryParams.mode = undefined
  queryParams.chargeType = undefined
  queryParams.memberOnly = undefined
  queryParams.stime = []
  activeTab.value = ''
  handleQuery()
}

const handleTabChange = (val: any) => {
  if (val === '') {
    queryParams.status = undefined
  } else {
    queryParams.status = Number(val)
  }
  handleQuery()
}

onMounted(() => {
  const statusFromQuery = route.query.status
  if (statusFromQuery !== undefined && statusFromQuery !== '') {
    const status = Number(statusFromQuery)
    if (!Number.isNaN(status)) {
      activeTab.value = status
      queryParams.status = status
    }
  } else if (route.path.endsWith('/audit')) {
    activeTab.value = 1
    queryParams.status = 1
  }
  loadCategoryList()
  loadTagList()
  loadAreaTree()
  getList()
  getPendingCount()
})

/** ===== 省市区三级联动（系统地区树 id = 行政区划代码） ===== */
const areaTree = ref<any[]>([])
const areaCascaderProps = {
  value: 'id',
  label: 'name',
  children: 'children',
  emitPath: true
}
const amapRef = ref<InstanceType<typeof AmapDialog>>()

const loadAreaTree = async () => {
  if (areaTree.value.length) return
  try {
    areaTree.value = (await getAreaTree()) || []
  } catch (e) {
    areaTree.value = []
  }
}

/** 级联变更 → 回填 cityCode / districtCode（后端仍存区划代码） */
const onRegionChange = (value: number[] | null) => {
  const path = value || []
  formData.regionPath = path
  if (path.length >= 3) {
    formData.cityCode = String(path[1])
    formData.districtCode = String(path[2])
  } else if (path.length === 2) {
    formData.cityCode = String(path[1])
    formData.districtCode = ''
  } else if (path.length === 1) {
    formData.cityCode = String(path[0])
    formData.districtCode = ''
  } else {
    formData.cityCode = ''
    formData.districtCode = ''
  }
}

/** 编辑回显：按城市/区县代码反查省→市→区路径 */
const findRegionPathByCodes = (
  tree: any[],
  cityCode?: string,
  districtCode?: string
): number[] => {
  if (!tree?.length || (!cityCode && !districtCode)) return []
  const cityId = cityCode ? Number(cityCode) : NaN
  const districtId = districtCode ? Number(districtCode) : NaN
  for (const province of tree) {
    for (const city of province.children || []) {
      const cityMatch =
        (!Number.isNaN(cityId) && city.id === cityId) || String(city.id) === String(cityCode)
      if (!cityMatch) continue
      if (districtCode) {
        const district = (city.children || []).find(
          (d: any) =>
            (!Number.isNaN(districtId) && d.id === districtId) ||
            String(d.id) === String(districtCode)
        )
        if (district) return [province.id, city.id, district.id]
      }
      return [province.id, city.id]
    }
  }
  // 直辖市等：区挂在省下第二层时，用区县代码兜底
  if (districtCode) {
    for (const province of tree) {
      for (const city of province.children || []) {
        const district = (city.children || []).find(
          (d: any) =>
            (!Number.isNaN(districtId) && d.id === districtId) ||
            String(d.id) === String(districtCode)
        )
        if (district) return [province.id, city.id, district.id]
      }
    }
  }
  return []
}

const syncRegionPathFromCodes = () => {
  formData.regionPath = findRegionPathByCodes(
    areaTree.value,
    formData.cityCode,
    formData.districtCode
  )
}

/** 打开高德选点（带入当前已填坐标） */
const openMapPicker = () => {
  const lng = formData.lng != null && formData.lng !== '' ? Number(formData.lng) : NaN
  const lat = formData.lat != null && formData.lat !== '' ? Number(formData.lat) : NaN
  amapRef.value?.open(
    Number.isFinite(lng) ? lng : undefined,
    Number.isFinite(lat) ? lat : undefined
  )
}

/** 地图选点确认：回填经纬度；有地址则同步；尽量同步省市区级联 */
const handleMapConfirm = (data: {
  longitude: number
  latitude: number
  address: string
  province: string
  city: string
  district: string
}) => {
  formData.lng = String(data.longitude)
  formData.lat = String(data.latitude)
  if (data.address) {
    formData.address = data.address
  }
  if (data.province || data.city || data.district) {
    const path = findStoreAreaPathByNames(
      areaTree.value,
      data.province,
      data.city,
      data.district
    )
    if (path?.length) {
      onRegionChange(path)
    }
  }
  message.success('已从地图选点回填经纬度')
  formRef.value?.clearValidate?.(['lng', 'lat', 'address', 'regionPath'])
}

// ===== 表单弹窗 =====
const dialogVisible = ref(false)
const dialogTitle = ref('')
const submitLoading = ref(false)
const formRef = ref()
const formData = reactive<any>({
  id: undefined,
  role: 1,
  memberId: 0,
  categoryId: undefined,
  tagIds: [],
  mode: 1,
  cityCode: '',
  districtCode: '',
  /** 前端级联路径 [省id, 市id, 区id]，提交前不传后端 */
  regionPath: [] as number[],
  title: '',
  subtitle: '',
  keywords: '',
  description: '',
  companyName: '',
  speakerName: '',
  speakerTitle: '',
  signupNotice: '',
  cover: '',
  bigCover: '',
  address: '',
  busLine: '',
  lng: '',
  lat: '',
  stime: '',
  etime: '',
  bmStime: '',
  bmEtime: '',
  checkinStartTime: '',
  checkinEndTime: '',
  maxNum: 100,
  maleLimit: 0,
  femaleLimit: 0,
  minAge: 0,
  maxAge: 0,
  memberOnly: false,
  chargeType: 1,
  signupAuditEnabled: false,
  signupFormSchema: '[]',
  signNum: 0,
  bmPrice: 0,
  points: 0,
  isRec: false,
  // 评价开关默认开放：库里 NULL/缺省就是开放，新建时不传等于开放，但表单要有明确值可回显
  reviewEnabled: true,
  displayOrder: 0,
  views: 0,
  shareNum: 0,
  status: 0,
  subStatus: 1,
  intro: '',
  activityDescription: '',
  review: ''
})
const formRules = {
  title: [{ required: true, message: '活动标题不能为空', trigger: 'blur' }],
  subtitle: [{ required: true, message: '活动副标题不能为空', trigger: 'blur' }],
  categoryId: [{ required: true, message: '请选择活动分类', trigger: 'change' }],
  companyName: [{ required: true, message: '活动单位不能为空', trigger: 'blur' }],
  cover: [{ required: true, message: '封面图不能为空', trigger: 'blur' }],
  bigCover: [{ required: true, message: '封面图二不能为空', trigger: 'blur' }],
  regionPath: [
    {
      required: true,
      validator: (_rule: any, value: number[], callback: (err?: Error) => void) => {
        if (!value || value.length < 3) {
          callback(new Error('请选择完整的省 / 市 / 区'))
          return
        }
        callback()
      },
      trigger: 'change'
    }
  ],
  address: [{ required: true, message: '活动地址不能为空', trigger: 'blur' }],
  lng: [{ required: true, message: '请通过地图选点填写经度', trigger: 'change' }],
  lat: [{ required: true, message: '请通过地图选点填写纬度', trigger: 'change' }],
  stime: [{ required: true, message: '活动开始时间不能为空', trigger: 'change' }],
  etime: [{ required: true, message: '活动结束时间不能为空', trigger: 'change' }],
  bmStime: [{ required: true, message: '报名开始时间不能为空', trigger: 'change' }],
  bmEtime: [{ required: true, message: '报名结束时间不能为空', trigger: 'change' }],
  maxNum: [{ required: true, message: '参与人数不能为空', trigger: 'blur' }]
}

const signupFormFields = ref<any[]>([])
const addSignupField = () => {
  const index = signupFormFields.value.length + 1
  signupFormFields.value.push({ type: 'text', label: '', key: `field_${index}`, required: false })
}
const removeSignupField = (index: number) => signupFormFields.value.splice(index, 1)
const parseSignupFormSchema = (schema?: string) => {
  try {
    const fields = JSON.parse(schema || '[]')
    signupFormFields.value = Array.isArray(fields) ? fields : []
  } catch (e) {
    signupFormFields.value = []
  }
}

/** 后端 LocalDateTime 序列化为毫秒时间戳；日期选择器 value-format 需要字符串 */
const ACTIVITY_TIME_FIELDS = [
  'stime',
  'etime',
  'bmStime',
  'bmEtime',
  'checkinStartTime',
  'checkinEndTime'
] as const

const normalizeActivityTimeFields = (data: Record<string, any>) => {
  for (const key of ACTIVITY_TIME_FIELDS) {
    formData[key] = formatDate(data?.[key]) || ''
  }
}

const openForm = async (type: 'create' | 'update', id?: number) => {
  dialogVisible.value = true
  dialogTitle.value = type === 'create' ? '新增活动' : '编辑活动'
  resetForm()
  await loadAreaTree()
  if (id) {
    const data = await ActivityApi.getActivity(id)
    Object.assign(formData, data)
    // 老活动库里 review_enabled 可能是 null（列默认 1=开放）：Object.assign 会把 null 盖进来，
    // 直接绑给 el-switch 就显示成「关闭」，运营一保存就把这个场次的评价偷偷关了。
    formData.reviewEnabled = data.reviewEnabled !== false
    normalizeActivityTimeFields(data || {})
    formData.tagIds = (data.tags || []).map((tag: any) => tag.id)
    parseSignupFormSchema(data.signupFormSchema)
    syncRegionPathFromCodes()
    if (
      (formData.cityCode || formData.districtCode) &&
      (!formData.regionPath || formData.regionPath.length === 0)
    ) {
      message.warning('原城市/区县代码无法匹配地区库，请重新选择省市区')
    }
  }
}

const resetForm = () => {
  Object.assign(formData, {
    id: undefined,
    role: 1,
    memberId: 0,
    categoryId: undefined,
    tagIds: [],
    mode: 1,
    cityCode: '',
    districtCode: '',
    regionPath: [],
    title: '',
    subtitle: '',
    keywords: '',
    description: '',
    companyName: '',
    speakerName: '',
    speakerTitle: '',
    signupNotice: '',
    cover: '',
    bigCover: '',
    address: '',
    busLine: '',
    lng: '',
    lat: '',
    stime: '',
    etime: '',
    bmStime: '',
    bmEtime: '',
    checkinStartTime: '',
    checkinEndTime: '',
    maxNum: 100,
    maleLimit: 0,
    femaleLimit: 0,
    minAge: 0,
    maxAge: 0,
    memberOnly: false,
    chargeType: 1,
    signupAuditEnabled: false,
    signupFormSchema: '[]',
    signNum: 0,
    bmPrice: 0,
    points: 0,
    isRec: false,
    reviewEnabled: true,
    displayOrder: 0,
    status: 0,
    intro: '',
    activityDescription: '',
    review: ''
  })
  signupFormFields.value = []
  formRef.value?.clearValidate()
}

/** 报名费用驱动收费类型：0=免费，>0=收费 */
const syncChargeTypeByPrice = () => {
  const price = Number(formData.bmPrice ?? 0)
  formData.chargeType = price > 0 ? 2 : 1
}
/** 选免费时清零费用，避免「免费但金额>0」不一致 */
const onChargeTypeChange = (val: number) => {
  if (val === 1) {
    formData.bmPrice = 0
  }
}

const submitForm = async () => {
  await formRef.value?.validate()
  const invalidField = signupFormFields.value.some(
    (field) => !field.label?.trim() || !field.key?.trim()
  )
  if (invalidField) {
    message.warning('请完善报名字段名称和标识')
    return
  }
  const keySet = new Set<string>()
  const dupKey = signupFormFields.value.some((field) => {
    const key = field.key?.trim()
    if (!key) return false
    if (keySet.has(key)) return true
    keySet.add(key)
    return false
  })
  if (dupKey) {
    message.warning('报名字段标识不能重复')
    return
  }
  formData.signupFormSchema = JSON.stringify(signupFormFields.value)
  // 费用与收费类型对齐：0/空=免费，>0=收费（与 C 端、后端规则一致）
  const price = Number(formData.bmPrice ?? 0)
  formData.bmPrice = Number.isFinite(price) ? price : 0
  formData.points = Number(formData.points ?? 0) || 0
  formData.chargeType = formData.bmPrice > 0 ? 2 : 1
  // regionPath 仅前端级联用，不落库
  const { regionPath: _regionPath, ...payload } = formData
  submitLoading.value = true
  try {
    if (formData.id) {
      await ActivityApi.updateActivity(payload)
      message.success('修改成功')
    } else {
      await ActivityApi.createActivity(payload)
      message.success('新增成功')
    }
    dialogVisible.value = false
    getList()
    getPendingCount()
  } finally {
    submitLoading.value = false
  }
}

const handleDelete = async (id: number) => {
  await message.confirm('确定删除该活动？')
  await ActivityApi.deleteActivity(id)
  message.success('删除成功')
  getList()
  getPendingCount()
}

const handleClose = async (id: number) => {
  await message.confirm('确定关闭该活动？关闭后用户无法报名。')
  await ActivityApi.closeActivity(id)
  message.success('已关闭')
  getList()
}

const goSignups = (id: number) => {
  router.push({ path: '/ai-Application-center/activity/signup', query: { activityId: id } })
}

/** 该活动的举报列表：C 端活动详情「举报活动」提交的数据在这里看 */
const goReports = (id: number) => {
  router.push({ path: '/ai-Application-center/activity/report', query: { activityId: id } })
}

const checkinQrVisible = ref(false)
const checkinQr = reactive({
  title: '',
  tip: '',
  payload: '',
  dataUrl: '',
  checkinStartTime: '' as string | Date,
  checkinEndTime: '' as string | Date
})

const openCheckinQrcode = async (id: number) => {
  checkinQrVisible.value = true
  checkinQr.dataUrl = ''
  checkinQr.payload = ''
  const data = await ActivityApi.getActivityCheckinQrcode(id)
  checkinQr.title = data?.title || ''
  checkinQr.tip = data?.tip || '请已报名用户扫码签到'
  checkinQr.payload = data?.payload || ''
  checkinQr.checkinStartTime = data?.checkinStartTime || ''
  checkinQr.checkinEndTime = data?.checkinEndTime || ''
  if (checkinQr.payload) {
    checkinQr.dataUrl = await QRCode.toDataURL(checkinQr.payload, {
      width: 280,
      margin: 2
    })
  }
}

const copyCheckinPayload = async () => {
  if (!checkinQr.payload) return
  await navigator.clipboard.writeText(checkinQr.payload)
  message.success('已复制签到码内容')
}

// ===== 审核弹窗 =====
const auditDialogVisible = ref(false)
const auditSubmitting = ref(false)
const auditFormRef = ref()
const auditForm = reactive<any>({
  id: undefined,
  title: '',
  pass: true,
  reason: ''
})
const auditRules = {
  pass: [{ required: true, message: '请选择审核结果', trigger: 'change' }],
  reason: [
    {
      validator: (_: any, value: any, callback: any) => {
        if (auditForm.pass === false && !value) {
          return callback(new Error('拒绝时必须填写原因'))
        }
        callback()
      },
      trigger: 'blur'
    }
  ]
}

const openAudit = (row: any) => {
  auditDialogVisible.value = true
  auditForm.id = row.id
  auditForm.title = row.title
  auditForm.pass = true
  auditForm.reason = ''
  auditFormRef.value?.clearValidate()
}

const submitAudit = async () => {
  await auditFormRef.value?.validate()
  auditSubmitting.value = true
  try {
    await ActivityApi.auditActivity({
      id: auditForm.id,
      pass: auditForm.pass,
      reason: auditForm.reason
    })
    message.success('审核成功')
    auditDialogVisible.value = false
    getList()
    getPendingCount()
  } finally {
    auditSubmitting.value = false
  }
}

// ===== 素材选择器 =====
const mediaVisible = ref(false)
const mediaField = ref('')

const openMediaSelector = (field: string) => {
  mediaField.value = field
  mediaVisible.value = true
}

const onMediaConfirm = (items: any[]) => {
  if (items.length > 0) {
    ;(formData as any)[mediaField.value] = items[0].url
  }
}
</script>

<style scoped>
.checkin-qr-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 0 16px;
}
.checkin-qr-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  text-align: center;
}
.checkin-qr-img {
  width: 280px;
  height: 280px;
}
.checkin-qr-tip {
  margin-top: 16px;
  color: #666;
  font-size: 13px;
  text-align: center;
  line-height: 1.5;
}
.checkin-qr-time {
  margin-top: 8px;
  color: #333;
  font-size: 13px;
}
</style>
